// Import external
import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[synFieldLabel]'
})
export class FieldLabelDirective implements OnInit {

    constructor(private ele: ElementRef) {
    }

    ngOnInit() {
        this.ele.nativeElement.className = `${this.ele.nativeElement.className} syn-field__label`.trim();
    }
}
